import { FieldError } from 'react-aria-components';
import { cn } from '~/lib/utils';
import Icon from './Icon';

export function CustomFieldError({
  errorMessage,
  className,
}: {
  errorMessage?: string;
  className?: string;
}) {
  if (!errorMessage) {
    return null;
  }

  return (
    <FieldError className={cn('text-[13px] leading-[1.7] flex gap-2 items-center', className)}>
      <Icon name="error" /> {errorMessage}
    </FieldError>
  );
}
